<template>
    <div class="person">
        <div class="condition">
            <queryCondition ref="query" :list="queryList" :value="conditionData" labelWidth="120px" :search="selectData" :reset="reset"></queryCondition>
        </div>
        <div class="table">
            <div class="handle">
                <el-button type="" icon="el-icon-refresh-left" size="small" @click="loadingData()">刷新列表</el-button>
                <div v-if="lianta_issh!='1'">
                    <el-button type="primary" icon="el-icon-circle-plus" size="small" @click="addDialogShow()">新建</el-button>
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                :header-cell-style="tableHeaderColor"
                style="width: 100%">
                <el-table-column type="index" width="60" label="序号" align="center"></el-table-column>
                <el-table-column prop="userId" label="用户ID" align="center" width="88"></el-table-column>
                <el-table-column prop="nickName" label="昵称" align="center" width="140">
                    <template slot-scope="scope">
                        <div class="flexccc">
                            <el-image
                            style="width: 40px; height: 40px"
                            :src="scope.row.header"
                            :preview-src-list="[scope.row.header]"
                            v-if="scope.row.header"
                            fit="cover"></el-image>
                            <!-- {{ scope.row.nickName }} -->
                            <span>{{ scope.row.nickName }}<span style="color: red; font-size: 17px;">{{ scope.row.real ? '*' : '' }}</span></span>

                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="gender" label="性别" align="center" width="88">
                    <template slot-scope="scope">
                        <span>{{ scope.row.gender == 1 ? '男' : '女' }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="content" label="内容" align="center"></el-table-column>
                <el-table-column prop="title" label="标题" align="center" width="120"></el-table-column>
                <el-table-column prop="province" label="省" align="center" width="80"></el-table-column>
                <el-table-column prop="city" label="市" align="center" width="80"></el-table-column>
                <el-table-column prop="real" label="实名" align="center" width="80">
                    <template slot-scope="scope">
                        <span>{{ scope.row.real ? '是' : '否' }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="time" label="发布时间" align="center" width="160"></el-table-column>
                <el-table-column
                fixed="right"
                label="操作"
                width="120px"
                align="center"
                >
                <template slot-scope="scope">
                    <el-button type="text" icon="el-icon-edit" size="mini" @click="editTip(scope.row)">编辑</el-button>
                    <el-button type="text" icon="el-icon-delete" size="mini" @click="deleteTip(scope.row)">删除</el-button>
                    <!-- <el-button type="text" icon="el-icon-edit" size="mini" @click="chuli(scope.row)">处理</el-button> -->
                </template>
                </el-table-column>
            </el-table>
            <div class="page">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    background
                    layout="sizes, prev, pager, next, jumper"
                    :total="totalCount"
                    :page-sizes="[10, 20, 50, 100]"
                    :current-page="conditionData.page"
                    :page-size="conditionData.pageSize">
                </el-pagination>
            </div>
        </div>

        <el-dialog :close-on-click-modal="false" :visible.sync="isAddDialog" title="新增动态" width="720px">
            <div class="dialog">
                <div class="item">
                    <div class="label">
                        用户
                    </div>
                    <div class="value">
                        <el-input v-model="addData.nickName" size="small" placeholder="请选择用户" disabled></el-input>
                        <el-button type="primary" size="small" @click="isUserDialog = true">点击选择</el-button>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        主题
                    </div>
                    <div class="value">
                        <el-select v-model="addData.title2" filterable clearable placeholder="请选择主题" size="small" @change="title2Change">
                            <el-option
                            v-for="item in taglist"
                            :key="item.title"
                            :label="item.title"
                            :value="item.title">
                            </el-option>
                        </el-select>
                        <!-- <el-input v-model="addData.title2" size="small" placeholder="请输入主题" @input="inputChange"></el-input> -->
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        省份
                    </div>
                    <div class="value">
                        <el-input v-model="addData.province" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        城市
                    </div>
                    <div class="value">
                        <el-input v-model="addData.city" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        动态内容(选填,需审核)
                    </div>
                    <div class="value">
                        <el-input v-model="addData.content" size="small" placeholder="请输入" type="textarea" :rows="5"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        上传图片
                    </div>
                    <div class="value">
                        <el-upload
                            :action="uploadUrl"
                            multiple
                            :show-file-list="false"
                            :http-request="addImg"
                            >
                            <el-button size="small" type="primary">点击上传</el-button>
                        </el-upload>
                    </div>
                </div>
                
                <div class="picList">
                    <div class="pic" v-for="(item,index) in addData.pathList" :key="index">
                        <el-image
                        style="width: 100px; height: 100px"
                        :src="item"
                        :preview-src-list="[item]"
                        fit="cover"

                        ></el-image>
                        <img class="pic-edit" src="../../../assets/images/icon08.png" alt="" @click="clearAddPath(index)">
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        发布时间
                    </div>
                    <div class="value">
                        <el-date-picker
                        v-model="addData.time"
                        type="datetime"
                        :picker-options="pickerOptions"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        placeholder="选择日期时间">
                        </el-date-picker>
                    </div>
                </div>
                <div class="item" v-if="addData.nickName">
                    <div class="label">
                        请选择用户相册图片
                    </div>
                </div>
                <div class="picList" v-if="addData.nickName">
                    <div :class="item.isSelect ? 'pic pic-this':'pic'" v-for="(item,index) in userPics" :key="index" @click="selectUserPic(index,1)">
                        <el-image
                        class=""
                        style="width: 100px; height: 100px; border-radius: 6px"
                        :src="item.path"
                        fit="cover"
                        ></el-image>
                    </div>
                </div>
                <div v-if="userPics.length==0&&addData.nickName">
                    <el-empty description="暂无图片"></el-empty>
                </div>
                <div class="btns">
                    <el-button type="primary" @click="add">确认编辑</el-button>
                </div>
            </div>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" :visible.sync="isEditDialog" title="编辑动态" width="720px">
            <div class="dialog">
                <div class="item">
                    <div class="label">
                        用户
                    </div>
                    <div class="value">
                        <el-input v-model="editData.nickName" size="small" placeholder="请选择用户" disabled></el-input>
                        <el-button type="primary" size="small" @click="isUserDialog = true">点击选择</el-button>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        主题
                    </div>
                    <div class="value">
                        <el-select v-model="editData.title2" filterable clearable placeholder="请选择主题" size="small" @change="title2Change">
                            <el-option
                            v-for="item in taglist"
                            :key="item.title"
                            :label="item.title"
                            :value="item.title">
                            </el-option>
                        </el-select>
                        <!-- <el-input v-model="editData.title2" size="small" placeholder="请输入主题" @input="inputChange"></el-input> -->
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        省份
                    </div>
                    <div class="value">
                        <el-input v-model="editData.province" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        城市
                    </div>
                    <div class="value">
                        <el-input v-model="editData.city" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        动态内容(选填,需审核)
                    </div>
                    <div class="value">
                        <el-input v-model="editData.content" size="small" placeholder="请输入" type="textarea" :rows="5"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        上传图片
                    </div>
                    <div class="value">
                        <el-upload
                            :action="uploadUrl"
                            multiple
                            :show-file-list="false"
                            :http-request="editImg"
                            >
                            <el-button size="small" type="primary">点击上传</el-button>
                        </el-upload>
                    </div>
                </div>
                <div class="picList">
                    <div class="pic" v-for="(item,index) in editData.pathList" :key="index">
                        <el-image
                        style="width: 100px; height: 100px"
                        :src="item"
                        :preview-src-list="[item]"
                        fit="cover"

                        ></el-image>
                        <img class="pic-edit" src="../../../assets/images/icon08.png" alt="" @click="clearEditPath(index)">
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        发布时间
                    </div>
                    <div class="value">
                        <el-date-picker
                        v-model="editData.time"
                        type="datetime"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        :picker-options="pickerOptions"
                        placeholder="选择日期时间">
                        </el-date-picker>
                    </div>
                </div>
                
                <div class="item" v-if="editData.nickName">
                    <div class="label">
                        请选择用户相册图片
                    </div>
                </div>
                <div class="picList" v-if="editData.nickName">
                    <div :class="item.isSelect ? 'pic-this':'pic'" v-for="(item,index) in userPics" :key="index" @click="selectUserPic(index,2)">
                        <el-image
                        style="width: 100px; height: 100px; border-radius: 6px"
                        :src="item.path"
                        fit="cover"
                        ></el-image>
                    </div>
                </div>
                <div v-if="userPics.length==0&&editData.nickName">
                    <el-empty description="暂无图片"></el-empty>
                </div>
                <div class="btns">
                    <el-button type="primary" @click="edit">确认编辑</el-button>
                </div>
            </div>
        </el-dialog>
        
        <el-dialog :close-on-click-modal="false" :visible.sync="isUserDialog" title="选择用户" width="1200px">
            <queryCondition ref="query" :list="queryUserList" :value="conditionUserData" labelWidth="120px" :search="selectUserData" :reset="resetUser"></queryCondition>
            <el-table
                :data="userList"
                border
                :header-cell-style="tableHeaderColor"
                height="500px"
                style="width: 100%">
                <el-table-column type="index" width="60" label="序号" align="center"></el-table-column>
                <el-table-column prop="nickName" label="昵称" align="center" width="110"></el-table-column>
                <!-- <el-table-column prop="phone" label="手机号码" align="center" width="120"></el-table-column> -->
                <el-table-column prop="header" label="头像" align="center">
                    <template slot-scope="scope">
                        <el-image
                        style="width: 40px; height: 40px"
                        :src="scope.row.header"
                        :preview-src-list="[scope.row.header]"
                        v-if="scope.row.header"
                        fit="cover"></el-image>
                    </template>
                </el-table-column>
                <el-table-column prop="realName" label="实名认证" align="center" width="100">
                    <template slot-scope="scope">
                        <span v-if="scope.row.realName" style="color:#409eff">实名认证</span>
                        <span v-else>—</span>
                    </template>
                </el-table-column>
                <el-table-column prop="birthday" label="出生日期" align="center" width="100">
                    <template slot-scope="scope">
                        {{ scope.row.birthday }}
                    </template>
                </el-table-column>
                <el-table-column prop="age" label="年龄" align="center" width="60"></el-table-column>
                <el-table-column prop="currentAddress" label="现居住" align="center" width="100"></el-table-column>
                <el-table-column prop="placeAddress" label="户籍地" align="center" width="100"></el-table-column>
                <el-table-column prop="zhiYe" label="职业" align="center" width="100">
                    <template slot-scope="scope">
                        <span>{{ scope.row.zhiYe }}</span>
                        <span v-if="scope.row.isCareer" style="color:#409eff">(已认证)</span>
                    </template>
                </el-table-column>
                <el-table-column prop="height" label="身高" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.height }}CM
                    </template>
                </el-table-column>
                <el-table-column prop="weight" label="体重" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.weight }}KG
                    </template>
                </el-table-column>
                <el-table-column prop="education" label="学历" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.education == 1 ? '初中以下' : '' }}
                        {{ scope.row.education == 2 ? '高中' : '' }}
                        {{ scope.row.education == 3 ? '中专' : '' }}
                        {{ scope.row.education == 4 ? '大专' : '' }}
                        {{ scope.row.education == 5 ? '本科' : '' }}
                        {{ scope.row.education == 6 ? '硕士' : '' }}
                        {{ scope.row.education == 7 ? '博士' : '' }}
                        <span v-if="scope.row.isEducation" style="color:#409eff">(已认证)</span>
                    </template>
                </el-table-column>
                <el-table-column prop="income" label="收入" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.income == 1 ? '3k以上' : '' }}
                        {{ scope.row.income == 2 ? '5k以上' : '' }}
                        {{ scope.row.income == 3 ? '8k以上' : '' }}
                        {{ scope.row.income == 4 ? '12k以上' : '' }}
                        {{ scope.row.income == 5 ? '20k以上' : '' }}
                        {{ scope.row.income == 6 ? '50k以上' : '' }}
                        <span v-if="scope.row.isIncome" style="color:#409eff">(已认证)</span>
                    </template>
                </el-table-column>
                <el-table-column prop="familyBackground" label="家庭背景" align="center"></el-table-column>
                <el-table-column prop="onlyChild" label="独生子女" align="center" width="88">
                    <template slot-scope="scope">
                        {{ scope.row.onlyChild ? '是' : '否' }}
                    </template>
                </el-table-column>
                <el-table-column prop="marital" label="婚姻状况" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.marital == 1 ? '未婚' : '' }}
                        {{ scope.row.marital == 2 ? '离异' : '' }}
                        {{ scope.row.marital == 3 ? '丧偶' : '' }}
                    </template>
                </el-table-column>
                <el-table-column prop="marriedDate" label="何时结婚" align="center" width="130"></el-table-column>
                <el-table-column prop="houseqk" label="买房情况" align="center" width="100">
                    <template slot-scope="scope">
                        {{ scope.row.houseqk }}
                        <span v-if="scope.row.isRealEstate" style="color:#409eff">(已认证)</span>
                    </template>
                </el-table-column>
                <el-table-column prop="carqk" label="买车情况" align="center" width="100">
                    <template slot-scope="scope">
                        {{ scope.row.carqk }}
                        <span v-if="scope.row.isVehicle" style="color:#409eff">(已认证)</span>
                    </template>
                </el-table-column>
                <el-table-column prop="weChat" label="微信" align="center" width="120"></el-table-column>
                <el-table-column fixed="right" label="操作" width="100px" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" size="mini" @click="selectUser(scope.row)">确认</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="page">
                <el-pagination
                    @size-change="handleSizeChangeUser"
                    @current-change="handleCurrentChangeUser"
                    background
                    layout="sizes, prev, pager, next, jumper"
                    :total="totalCountUser"
                    :page-sizes="[10, 20, 50, 100]"
                    :current-page="conditionUserData.page"
                    :page-size="conditionUserData.pageSize">
                </el-pagination>
            </div>
        </el-dialog>

        
    </div>
</template>
<script>
import api from '../../../api/main'
import queryCondition from '../../../components/queryCondition'
import forms from '../../../components/form'
import {parseTimeS} from '../../../utils/index'
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
import { CodeToText,TextToCode } from "element-china-area-data";

const genderList = [
    {
        value: 1,
        label: '男',
    },{
        value: 2,
        label: '女',
    }
]
export default {
    name: 'person',
    components:{
        queryCondition,
        forms,
        ElImageViewer
    },
    watch: {
    },
    data () {
        return {
            lianta_issh:localStorage.getItem('lianta_issh'),

            pickerOptions: {
                disabledDate(time) {
                    // return time.getTime() > Date.now() - 8.64e7;
                    return time.getTime() > Date.now();
                },
                selectableRange: '00:00:00 - 23:59:59'
            },
            uploadUrl: '',
            isAddDialog:false,
            isUpdateDialog:false,
            isDetailDialog:false,
            isUserDialog:false,
            formData:{
               
            },
           
            totalCount:0,
            tableData:[],
            RoleCount:0,
            RoleData:[],
            conditionData:{
                phone:"",
                province:"",
                city: "",
                gender:null,
                page:1,
                pageSize:10,
            },
            addData: {
                "nickName": null,
                "gender": null,
                "userId": null,
                "lng": 0,
                "lat": 0,
                "content": "",
                "title": "",
                "title2": "",
                "pathList": [
                    
                ],
                "province": "",
                "city": ""
            },
            editData: {
                "userId": null,
                "content": "",
                "title": "",
                "title2": "",
                "pathList": [
                    
                ],
                "province": "",
                "city": ""
            },
            isEditDialog: false,
            queryList:[
                {type: "input",label: "用户ID:",name: "userId"},
                {type: "input",label: "省份:",name: "province"},
                {type: "input",label: "城市:",name: "city"},
                {type: "select",label: "性别:",name: "gender",options:genderList},
            ],
            
            formList:[
                {type: "input",label: "账号:",name: "userName",valueWidth:"450px"},
                {type: "input",label: "昵称:",name: "nickName",valueWidth:"450px"},
                {type: "header",label: "头像:",name: "imgUrl"},
                {type: "select",label: "性别:",name: "sex",options:[{label:'未知',value:0},{label:'男',value:1},{label:'女',value:2}]},
                {type: "select",label: "状态:",name: "status",options:[{label:'开启',value:1},{label:'不开启',value:0}]},
            ],
            
            // 提交规则
            formRules:{
                areaName: [{ required: true, message: '请填写区域名称', trigger: 'blur' }],
                areaCode: [{ required: true, message: '请填写区域编号', trigger: 'blur' }],
            },
            
            formDetailBtns:[
                {name:'关闭',icon:'el-icon-error',type:'warning',handleClick:this.close},
                // {name:'确认编辑',icon:'el-icon-edit',type:'primary',handleClick:this.edit}
            ],
            formAddBtns:[
                {name:'关闭',icon:'el-icon-error',type:'warning',handleClick:this.close},
                {name:'确认新增',icon:'el-icon-circle-plus',type:'primary',handleClick:this.add}
            ],
            
            datelist:[],
            inviteData:{
                
            },
            userList:[],
            userCount:[],
            taglist:[],

            queryUserList:[
                {type: "input",label: "用户ID:",name: "UserId"},
                // {type: "input",label: "手机号:",name: "Phone"},
                {type: "input",label: "昵称:",name: "NickName"},
                {type: "select",label: "性别:",name: "Gender",options:[{ label: '男', value: 1 },{ label: '女', value: 2 }]},
                // {type: "select",label: "用户状态:",name: "State",options:[{ label: '正常', value: 1 },{ label: '注销', value: -2 },{ label: '封禁', value: -1 },{ label: '信息未完善', value: 0 }]},
                {type: "input",label: "省:",name: "Province"},
                {type: "input",label: "市:",name: "City"},

            ],
            conditionUserData:{
                UserId: "",
                Phone: "",
                NickName: "",
                Gender: null,
                Province: null,
                City: null,
                Area: null,
                State: null,
                Vip: null,
                RealName: null,
                IsEducation: null,
                IsRealEstate: null,
                IsVehicle: null,
                IsIncome: null,
                IsCareer: null,
                keyword:'',
                page:1,
                pageSize:10,
                Real:false
               
            },
            userPics:[],
            totalCountUser:0
        }
    },
    created(){
    },
    mounted(){
        this.loadingData();
        this.getUserList();
        this.getTagList();
    },
    methods:{
        disabledDate(time){
            return time.getTime() > Date.now() - 8.64e7; // 8.64e7 毫秒数代表一天
        },
        addressChange(e){
           
            if(CodeToText[e[0]]){
                this.conditionUserData.Province=CodeToText[e[0]];
            }else{
                this.conditionUserData.Province=''
            }
            if(CodeToText[e[1]]){
                this.conditionUserData.City=CodeToText[e[1]];
            }else{
                this.conditionUserData.City=''
            }
            if(CodeToText[e[2]]){
                this.conditionUserData.Area=CodeToText[e[2]];
            }else{
                this.conditionUserData.Area=''
            }
           
        },
        async getTagList(){
            let res = await api.GetDynamicTags();
            this.taglist = res.data.data;
        },
        getCurrentDate(){
            const currentDate = new Date();
            const year = currentDate.getFullYear();
            const month = (currentDate.getMonth() + 1) > 9 ? (currentDate.getMonth() + 1) : '0' + (currentDate.getMonth() + 1);
            const day = currentDate.getDate() > 9 ? currentDate.getDate() : '0' + currentDate.getDate();
            const hh = currentDate.getHours() > 9 ? currentDate.getHours() : '0' + currentDate.getHours();
            const mm = currentDate.getMinutes() > 9 ? currentDate.getMinutes() : '0' + currentDate.getMinutes();
            const ss = currentDate.getSeconds() > 9 ? currentDate.getSeconds() : '0' + currentDate.getSeconds();
            return year + "-" + month + "-" + day + ' ' + hh + ':' + mm + ':' + ss 
        },
        clearAddPath(i){
            for(let index in this.userPics){
                
                if(this.userPics[index].path == this.addData.pathList[i]){
                    this.userPics[index].isSelect = false
                    this.addData.pathList.splice(i, 1)
                    return;
                }
            }
            this.addData.pathList.splice(i, 1)

        },
        clearEditPath(i){
            for(let index in this.userPics){
                if(this.userPics[index].path == this.editData.pathList[i]){
                    this.userPics[index].isSelect = false
                    this.editData.pathList.splice(i, 1)
                    return;
                }
            }
            this.editData.pathList.splice(i, 1)

        },
        async addImg(e){
            let res = await api.uploadImage(e.file);
            this.addData.pathList.push(res)
        },
        selectUser(e){
            this.isUserDialog = false
            this.addData.nickName = e.nickName
            this.addData.userId = e.userId
            this.addData.gender = e.gender
            this.addData.province = e.province
            this.addData.city = e.city
            this.addData.lng = e.lng
            this.addData.lat = e.lat
            this.getUserPics(e.userId)
        },
        async getUserPics(id){
            let res = await api.GetUserPics(id);
            this.userPics = res.data.data;
        },
        selectUserPic(i, type){
            if(this.userPics[i].isSelect){
                this.userPics[i].isSelect = false;
                if(type == 1) {
                    for(let index in this.addData.pathList) {
                        if(this.addData.pathList[index] == this.userPics[i].path) {
                            this.addData.pathList.splice(index, 1)
                            return;
                        }
                    }
                } else {
                    for(let index in this.editData.pathList) {
                        if(this.editData.pathList[index] == this.userPics[i].path) {
                            this.editData.pathList.splice(index, 1)
                            return;
                        }
                    }
                }
            }else{
                this.userPics[i].isSelect = true;
                if(type == 1){
                    this.addData.pathList.push(this.userPics[i].path)
                }else{
                    this.editData.pathList.push(this.userPics[i].path)
                }
            }
            
        },
        deleteTip(item){
            this.$confirm('将删除此动态?', '是否继续', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.del(item);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消退出'
                });          
            });
        },
        async del(item){
            let res = await api.DeleteDynamic({
                "userId": item.userId,
                "id": item.id
            });
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '删除成功'
                });  
                this.loadingData();
            }
        },
        editTip(item){
            this.isEditDialog = true;
            this.editData = item;
            let title0 = JSON.parse(this.editData.title)[0]
            this.editData.title2 = title0
            this.getUserPics(item.userId)

        },
        title2Change(e){
            this.$forceUpdate()
        },
        async edit(){
            if(!this.editData.title2){
                this.$message({
                    type: 'warning',
                    message: '请选择主题'
                })
                return;
            }
            this.editData.title = JSON.stringify([this.editData.title2])
            let res = await api.EditDynamic(this.editData);
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '修改成功'
                })
                this.isEditDialog = false;
                this.loadingData();
                this.editData = {
                    "userId": null,
                    "content": "",
                    "title": "",
                    "pathList": [
                        
                    ],
                    "province": "",
                    "city": ""
                }
            }
        },

        async add(){
            if(!this.addData.title2){
                this.$message({
                    type: 'warning',
                    message: '请选择主题'
                })
                return;
            }
            this.addData.title = JSON.stringify([this.addData.title2])
            let res = await api.AddDynamic(this.addData);
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '新增成功'
                })
                this.isAddDialog = false;
                this.loadingData();
                this.addData = {
                    "userId": null,
                    "content": "",
                    "title": "",
                    "pathList": [
                        
                    ],
                    "province": "",
                    "city": ""
                }
            }
        },

        inputChange(){
            this.$forceUpdate()
        },
        async getUserList(){
            
            let res  = await api.UserPager(this.conditionUserData);
            this.userList = res.data.data.data;
            this.totalCountUser = res.data.data.totalCount;
           
        },
        close(){
            if(this.isAddDialog){
                this.isAddDialog = false
            }else if(this.isUpdateDialog){
                this.isUpdateDialog = false
                this.$refs["formListEdit"].resetFields();
            }else if(this.isDetailDialog){
                this.isDetailDialog = false
            }
        },
        
        // 图片查看
        closeViewer(){
            this.showBigImg = false;
        },
        
        // table表头样式
        tableHeaderColor ({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return 'background-color: #F2F2F2;color: #000;'
            }
        },
        
        // 加载table数据
        async loadingData() {
            let res  = await api.GetDynamic(this.conditionData);
            this.tableData = res.data.data.data;
            this.totalCount = res.data.data.totalCount;
        },
        
        // 查询
        selectData(){
            this.conditionData.page = 1;
            this.loadingData();
        },
        // 重置查询
        reset(){
            this.datelist = []
            this.conditionData = {
                startTime: "",
                endTime: "",
                phone: "",
                keyword:'',
                page:1,
                pageSize:10,
            },
            this.loadingData();
        },
        // 切换页面
        handleCurrentChange(page){
            this.conditionData.page = page;
            this.loadingData();
        },
        // 切换页面条数
        handleSizeChange(pageSize){
            this.conditionData.page = 1;
            this.conditionData.pageSize = pageSize;
            this.loadingData();
        },

        handleCurrentChangeUser(page){
            this.conditionUserData.page = page;
            this.getUserList();
        },
        // 切换页面条数
        handleSizeChangeUser(pageSize){
            this.conditionUserData.page = 1;
            this.conditionUserData.pageSize = pageSize;
            this.getUserList();
        },
        addDialogShow(){
            this.isAddDialog = true;
        },
        async isDetailDialogShow(row){
            this.isDetailDialog = true;
            this.formData = row;
            let res = await api.ServiceMerchantUsersInfo({id:row.id});
        },
        
        async editImg(e){
            let res = await api.uploadImage(e.file);
            this.editData.pathList.push(res)
        },

        // 查询
        selectUserData(){
            this.conditionUserData.page = 1;
            this.getUserList();
        },
        // 重置查询
        resetUser(){
            this.conditionUserData = {
                UserId: "",
                Phone: "",
                NickName: "",
                Gender: null,
                Province: null,
                City: null,
                Area: null,
                State: null,
                Vip: null,
                RealName: null,
                IsEducation: null,
                IsRealEstate: null,
                IsVehicle: null,
                IsIncome: null,
                IsCareer: null,
                keyword:'',
                page:1,
                pageSize:10,
                Real:false
            };
            this.getUserList();
        },
    }
    
}
</script>

<style lang="scss" scoped>
    .person{
        height: 100%;
    }
    .condition{
        background-color: #ffffff;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        border-radius: 5px;
        padding: 15px;
        font-size: 14px;
    }
    .condition .lable{
        display: flex;
        align-items: center;
        width: 80px;
    }
    .condition-item{
        display: flex;
        margin: 10px;
        margin-left: 0px;

    }
    .condition .btns{
        margin: 10px;
        margin-left: 80px;
    }
    .table{
        margin-top: 10px;
        background-color: #ffffff;
        padding: 15px;
        .handle{
            width: 100%;
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            padding-bottom: 15px;
            align-items: center;
            font-size: 20px;
        }
        .page{
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 16px;
            .el-pagination{
                margin-left: -10px;
            }
        }
    }
    
    .qrcodedivd{
        display: flex;
        justify-content: center;
    }
    #qrCode {
        display: inline-block;
        margin: 0 auto; /*水平居中*/
        position: relative;
        top: 15%;
        
        img {
            width: 200px;
            height: 200px;
            background-color: #fff; //设置白色背景色
            padding: 6px; // 利用padding的特性，挤出白边
        }
    }
    /deep/.el-image-viewer__canvas{
        img{
            height: 50%;
        }
    }
    /deep/.el-input.is-disabled .el-input__inner{
        color: #000000;
    }
    .pic{
        border-radius: 6px;
        width: 100px;
        height: 100px;
    }
    .pic-this {
        border: 1px solid #0e73e8;
        border-radius: 6px;
        overflow: hidden;
        width: 98px;
        height: 98px;
    }
    .flexccc{
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
    }
    /deep/.el-empty{
        padding-top: 0;
    }
</style>
